import * as React from "react";
import { SummaryLoader } from "@grandvisionhq/common";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { Hooks } from "@grandvisionhq/stores-v2";
import { usePreferredStoreFormSlots } from "../../../../../../slots/slots/PreferredStoreFormSlotsContext.js";
const PreferredStoreSummary = ({ preferredStoreId, onEdit, className }) => {
  const intl = useIntl();
  const {
    Slots: { summary: Summary }
  } = usePreferredStoreFormSlots();
  const [storeDetailsQuery, storeDetailsQueryState] = Hooks.useStoreDetailsWithGlobalStoreId();
  const store = storeDetailsQueryState.data;
  React.useEffect(() => {
    if (preferredStoreId) {
      storeDetailsQuery(preferredStoreId);
    }
  }, [preferredStoreId, storeDetailsQuery]);
  if (!Summary) {
    return null;
  }
  if (storeDetailsQueryState.loading) {
    return /* @__PURE__ */ React.createElement(SummaryLoader, null);
  }
  if (storeDetailsQueryState.error) {
    return /* @__PURE__ */ React.createElement(
      Alert,
      {
        variant: "info",
        className: "alert-m-default",
        title: intl.getFormattedLabel("account.profile.preferredStore.notFound", {
          parseLink: true
        })
      }
    );
  }
  if (!store) {
    return /* @__PURE__ */ React.createElement("span", null, intl.getLabel("account.profile.preferredStore.noStoreSelected"));
  }
  const values = {
    storeName: store.name,
    streetName: store.streetName,
    streetNumber: store.streetNumber ?? "",
    postalCode: store.postalCode ?? "",
    town: store.town
  };
  return /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(Summary, { actions: { onEdit }, values }));
};
export {
  PreferredStoreSummary as default
};
//# sourceMappingURL=PreferredStoreSummary.js.map
